import { render, staticRenderFns } from "./ShipmentDetailsSkeleton.vue?vue&type=template&id=30ad7314&scoped=true"
var script = {}
import style0 from "./ShipmentDetailsSkeleton.vue?vue&type=style&index=0&id=30ad7314&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ad7314",
  null
  
)

export default component.exports